export const addUTMSource = (link) => {
  if (!/utm_/.test(link)) {
    if (link.includes('?')) {
      link += '&utm_source=landing_eventos';
    } else {
      link += '?utm_source=landing_eventos';
    }
  }
  return link;
}